const state = () => ({
  isValid: false,
  date: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  date(state) {
    return state.date;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateDate(state, payload) {
    state.date = payload;
  }
};

const actions = {
  updateDate({ commit }, payload) {
    commit('updateDate', payload);
  }
};

export const date = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
